module.exports = __webpack_public_path__ + "78ac04163142cfc5b278425421f95d5e.MP3";